import React from 'react';
import ServicePage from './ServicePage';
import { faPalette } from '@fortawesome/free-solid-svg-icons';
import UIUXImage from "../assets/Uiux.jpg";
import styled from 'styled-components';

const DesignCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  
  @media (max-width: 992px) {
    flex: 0 0 40%;
  }
  
  @media (max-width: 768px) {
    flex: 0 0 85%;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const ToolTag = styled.div`
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 14px;
  font-weight: 500;
  margin: 5px;
  
  @media (max-width: 576px) {
    padding: 10px 20px;
    font-size: 13px;
  }
`;

const ToolsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  
  @media (max-width: 576px) {
    gap: 10px;
  }
`;

const UIDesignPage = () => {
  const features = [
    'User research and persona development',
    'Wireframing and prototyping',
    'Visual design and branding',
    'Interaction design',
    'Usability testing',
    'Responsive design across all devices'
  ];

  const additionalContent = (
    <div>
      <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333', textAlign: 'center' }}>
        Our UI/UX Design Approach
      </h3>
      <CardContainer>
        <DesignCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>User Research</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We begin with comprehensive user research to understand your target audience's needs, behaviors, and pain points. This foundation ensures we create designs that truly resonate with users.
          </p>
        </DesignCard>
        <DesignCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Wireframing & Prototyping</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We create detailed wireframes and interactive prototypes that visualize the user journey and interface structure, allowing for early testing and refinement before full development.
          </p>
        </DesignCard>
        <DesignCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Visual Design</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Our design team crafts visually stunning interfaces that align with your brand identity while prioritizing usability and accessibility for all users.
          </p>
        </DesignCard>
        <DesignCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Usability Testing</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We conduct thorough usability testing throughout the design process to identify and address potential issues, ensuring a seamless and intuitive user experience.
          </p>
        </DesignCard>
      </CardContainer>
      
      <h3 style={{ fontSize: '24px', fontWeight: '600', margin: '50px 0 20px', color: '#333', textAlign: 'center' }}>
        Design Tools & Technologies
      </h3>
      <ToolsContainer>
        <ToolTag>Figma</ToolTag>
        <ToolTag>Adobe XD</ToolTag>
        <ToolTag>Sketch</ToolTag>
        <ToolTag>InVision</ToolTag>
        <ToolTag>Adobe Photoshop</ToolTag>
        <ToolTag>Adobe Illustrator</ToolTag>
        <ToolTag>Zeplin</ToolTag>
        <ToolTag>Principle</ToolTag>
      </ToolsContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faPalette}
      title="UI/UX Design"
      subtitle="User-centered design solutions that create intuitive, engaging, and memorable digital experiences."
      description={["At Zenitech Solutions, our UI/UX Design services are crafted to deliver visually captivating, user-centric digital experiences that drive engagement and customer satisfaction. We combine innovative design with intuitive interfaces to ensure seamless user interactions across all devices and platforms.",

        "Whether you're building a brand-new product, refining an existing interface, or enhancing the user experience of your app or website, our team of expert designers works closely with you to create user-friendly, accessible, and aesthetically pleasing designs that align perfectly with your business goals.",
        
        "We focus on delivering fluid navigation, consistent branding, and responsive designs that enhance usability and maximize user retention. From concept to implementation, we ensure that every touchpoint is optimized for both beauty and functionality, creating an experience that delights users and drives results.",
        
        "With Zenitech Solutions, you don’t just get great design — you get design that engages, inspires action, and builds lasting connections with your audience."]}
      features={features}
      imagePath={UIUXImage}
      additionalContent={additionalContent}
      featuresDesciption="We offer custom UI/UX design solutions tailored to your business needs, focusing on creating seamless, engaging user experiences. Our expert team combines creativity with precision, ensuring that every design is not only visually stunning but also functional, intuitive, and user-centered."
      metaTitle="UI/UX Design Services"
      metaDescription="Our UI/UX Design services create visually captivating, user-centric digital experiences that drive engagement and customer satisfaction. From concept to implementation, we ensure every touchpoint is optimized for both beauty and functionality."
    />
  );
};

export default UIDesignPage;